module.exports = __webpack_public_path__ + "media/images/Panning for Gold-bd4a5e35.webp";